import { render, staticRenderFns } from "./Usuaris.vue?vue&type=template&id=3327b686&"
import script from "./Usuaris.vue?vue&type=script&lang=js&"
export * from "./Usuaris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports